module.exports = __webpack_public_path__ + "img/head_bg.9632a108.png";